import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const TIMEOUT_MS = 10 * 60 * 1000;
const WARNING_MS = 8 * 60 * 1000;
const COUNTDOWN_S = 2 * 60;

export default function useInactivityTimeout() {
  const navigate = useNavigate();
  const warningTimer = useRef(null);
  const logoutTimer = useRef(null);
  const countdownRef = useRef(null);
  const showWarningRef = useRef(false);
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_S);

  function logout() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    showWarningRef.current = false;
    setShowWarning(false);
    navigate("/login");
  }

  const resetTimers = useCallback(() => {
    clearTimeout(warningTimer.current);
    clearTimeout(logoutTimer.current);
    clearInterval(countdownRef.current);
    showWarningRef.current = false;
    setShowWarning(false);
    setCountdown(COUNTDOWN_S);

    warningTimer.current = setTimeout(() => {
      showWarningRef.current = true;
      setShowWarning(true);
      setCountdown(COUNTDOWN_S);

      countdownRef.current = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }, WARNING_MS);

    logoutTimer.current = setTimeout(() => {
      logout();
    }, TIMEOUT_MS);
  }, []);

  function stayLoggedIn() {
    resetTimers();
  }

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keypress", "touchstart", "scroll", "click"];

    function handleActivity() {
      if (!showWarningRef.current) resetTimers();
    }

    events.forEach(e => window.addEventListener(e, handleActivity));
    resetTimers();

    return () => {
      events.forEach(e => window.removeEventListener(e, handleActivity));
      clearTimeout(warningTimer.current);
      clearTimeout(logoutTimer.current);
      clearInterval(countdownRef.current);
    };
  }, []);

  return { showWarning, countdown, stayLoggedIn };
}